import * as yup from 'yup'

import constants from 'constants/index'

const { DUE_DILIGENCE_FILE_TYPES, DUE_DILIGENCE_FILE_MIMES_TYPES } =
  constants.technicalFaqs

const schema = yup.object().shape({
  kind: yup
    .string()
    .oneOf(['attach', 'link'])
    .required('Selecione o tipo de anexo'),
  content: yup
    .string()
    .max(5000, 'Quantidade de caracteres acima do permitido!'),
  fileUrl: yup
    .string()
    .url()
    .when('kind', {
      is: 'link',
      then: (value) => value.required('O campo é obrigatório'),
    }),
  attachments: yup.mixed().fileUpload({
    types: DUE_DILIGENCE_FILE_TYPES,
    mimeTypes: DUE_DILIGENCE_FILE_MIMES_TYPES,
    required: { field: 'kind', is: 'attach' },
  }),
})

export default schema
